/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForMasterDataTtlGeneration extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForMasterDataTtlGeneration");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForMasterDataTtlGeneration.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForMasterDataTtlGeneration>): BackgroundJobPayloadForMasterDataTtlGeneration {
        let obj = Object.assign(new BackgroundJobPayloadForMasterDataTtlGeneration(), model);
        BackgroundJobPayloadForMasterDataTtlGeneration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForMasterDataTtlGeneration>): BackgroundJobPayloadForMasterDataTtlGeneration {
        if (!model) return null;
        return BackgroundJobPayloadForMasterDataTtlGeneration.newInstance(<BackgroundJobPayloadForMasterDataTtlGeneration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForMasterDataTtlGeneration) {
        if (!obj) return;

        models.BackgroundJobPayloadForMasterDataTtlGeneration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForMasterDataTtlGeneration): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForMasterDataTtlGeneration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Cloud provider for which master data sync is to be performed
     */
    cloud_provider: models.CloudServiceName;

}
